import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import InputController from "../../../../../core/ui/components/InputController";
import SelectController from "../../../../../core/ui/components/SelectController";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const GeneralTab = ({ errors, control, selects }) => {
    return (
        <Row>
            <Col sm={6}>
                <SelectController
                    label="Pensión"
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    placeholder="pension"
                    name="entidad_pension_id"
                    options={selects.pensionEntities}
                />
            </Col>
            <Col sm={6}>
                <InputController
                    type="text"
                    label="Contacto"
                    errors={errors}
                    control={control}
                    name="contacto"
                    rules={REQUIRED_RULE}
                    placeholder="Contacto"
                />
            </Col>
        </Row>
    );
};

GeneralTab.propTypes = {
    errors: PropTypes.object,
    control: PropTypes.object,
    selects: PropTypes.object,
};

export default GeneralTab;
